import React, { useEffect, useMemo, useState } from 'react';
import { getTiptapPortalMountPoint, PopupPosition } from '../../tiptapPopup';
import { createPortal } from 'react-dom';
import { CANVAS_VIEWPORT_ID } from '../../../../canvas/utils/canvasConstants';
import BoardLinkPopupContent from './BoardLinkPopupContent';
import { Popover } from '@milanote/roma';

export type SelectedBoard = {
    boardId: string;
    permissionId?: string;
    title: string;
    color?: string;
    url?: string;
};

type BoardLinkPopupProps = {
    position: PopupPosition | null;
    isOpen: boolean;
};

const BoardLinkPopup: React.FC<BoardLinkPopupProps> = ({ isOpen, position }) => {
    const [scrollOffset, setScrollOffset] = useState({ x: 0, y: 0 });
    const portalMountPoint = useMemo(() => getTiptapPortalMountPoint(), []);

    useEffect(() => {
        if (!isOpen) return;

        const canvasViewport = document.getElementById(CANVAS_VIEWPORT_ID);
        if (!canvasViewport) return;

        const initialScroll = { x: canvasViewport.scrollLeft, y: canvasViewport.scrollTop };
        const onViewportScroll = () => {
            const currentScroll = { x: canvasViewport.scrollLeft, y: canvasViewport.scrollTop };
            setScrollOffset({
                x: initialScroll.x - currentScroll.x,
                y: initialScroll.y - currentScroll.y,
            });
        };
        canvasViewport.addEventListener('scroll', onViewportScroll);
        return () => canvasViewport.removeEventListener('scroll', onViewportScroll);
    }, [isOpen]);

    if (!isOpen || !position) return null;

    const verticalPositionStyle =
        position.anchor === 'bottom'
            ? { top: position.point.y + scrollOffset.y }
            : { bottom: `calc(100% - ${position.point.y + scrollOffset.y}px)` };

    if (!portalMountPoint) return null;

    return createPortal(
        <div
            className="BoardLinkPopup"
            style={{
                transform: 'scale(1)',
                position: 'fixed',

                left: position.point.x + scrollOffset.x,
                ...verticalPositionStyle,
            }}
            onTouchStart={(e) => e.stopPropagation()}
        >
            <Popover.Base className="BoardLinkPopupSurface flex max-h-96 w-2xs flex-col overflow-hidden">
                <BoardLinkPopupContent />
            </Popover.Base>
        </div>,
        portalMountPoint,
    );
};

export default BoardLinkPopup;
